import { useState } from "react"
import IScalarForm, { SCALAR_TYPES } from "../interface/IScalarForm"
import Scalar from "./Scalar"
import { CSSBorderRadius } from "src/libs/interfaces/layouts"
import FieldInput from ".."
import { Collapse } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IBorderRadiusProps {
   
}
const BorderRadius = (props: IScalarForm): JSX.Element =>  {
    return <Scalar 
            { ...props } 
            rowClassName="width-auto"
            enabledForm={<BorderRadiusEnabled {...props} />}
            desabledForm={<BorderRadiusDisabled {...props} />}
        />
}
export default BorderRadius

export const BorderRadiusEnabled = (props: IScalarForm): JSX.Element =>  {
    const _value: CSSBorderRadius | undefined = props.value || props.default
    const isValueFull = () => {
        return !!_value?.borderBottomLeft || 
            !!_value?.borderBottomRight ||
            !!_value?.borderTopRight 
    }
    const [isFull, setIsFull] = useState<boolean>(isValueFull())

    const onChange = (value: number, field: keyof CSSBorderRadius, dop: any) => {
        let v: CSSBorderRadius | undefined = _value || {}
        v[field] = value
        if(props.onChange) {
            props.onChange(v, props.field, dop)
        }
    }

    return <div className="container">  
        <FieldInput
            value={_value?.border || 0}
            type={SCALAR_TYPES.SLIDER}
            min={props.min || 0}
            max={props.max || 200}
            labelStepSize={(props.max || 200)/ 4}
            stepSize={1}
            field="border"
            default={0} 
            onChange={onChange}
            title={__(isFull ? " Top right" : "")}
            editable
        /> 
        <div 
            className={`btn btn-link small ${ isFull ? "d-none" : "" }`} 
            onClick={() => setIsFull(true)}
        >
            <div className="small">
                {__("More then")}
            </div>
        </div>
        <Collapse
            isOpen={isFull}
        >
            <FieldInput
                value={_value?.borderBottomLeft || 0}
                type={SCALAR_TYPES.SLIDER}
                min={props.min || 0}
                max={props.max || 200}
                labelStepSize={(props.max || 200)/ 4}
                field="borderBottomLeft" 
                stepSize={1}
                default={0} 
                title={__("Bottom left")}
                onChange={onChange}
                editable
            />
            <FieldInput
                value={_value?.borderBottomRight || 0}
                type={SCALAR_TYPES.SLIDER}
                min={props.min || 0}
                max={props.max || 200}
                labelStepSize={(props.max || 200)/ 4}
                field="borderBottomRight" 
                stepSize={1}
                default={0} 
                onChange={onChange}
                title={__("Bottom right")}
                editable
            />
            <FieldInput
                value={_value?.borderTopRight || 0}
                type={SCALAR_TYPES.SLIDER}
                min={props.min || 0}
                max={props.max || 200}
                labelStepSize={(props.max || 200)/ 4}
                field="borderTopRight" 
                stepSize={1}
                default={0} 
                onChange={onChange}
                title={__("Top left")}
                editable
            />
        </Collapse> 
    </div>
}
export const BorderRadiusDisabled = (props: IScalarForm): JSX.Element =>  {
    return <div>{props.value || props.default || 0}</div>

}